import { currencyFormatter } from 'services/helpers';
import { SummaryItem } from 'components/VegasConference';

const PaymentSummary = ({ form, totalAmount }) => {
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-5 mb-6">
      <div className="flex flex-col sm:flex-row justify-between gap-3 mb-4">
        <h6 className="m-0 text-sm font-semibold text-[#13235f]">Billing Summary</h6>

        <p className="m-0 w-fit px-4 py-2 rounded-full text-sm font-bold bg-gradient-to-r from-[#c9a24b] to-[#e6c36f] text-white shadow-sm whitespace-nowrap">
          {currencyFormatter.format(totalAmount)}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
        <SummaryItem label="Name" value={form.primaryPerson.name} />
        <SummaryItem label="Franchise" value={form.company} />
        <SummaryItem label="Email" value={form.primaryPerson.email} />
        <SummaryItem label="Phone" value={form.primaryPerson.phone} />
      </div>
    </div>
  );
};

export default PaymentSummary;
